import { type NextRequest } from 'next/server'
// Aliased on import because the function is not a React hook despite its name —
// the same workaround every other call site in the monorepo uses.
import { useLocaleCredentials as setLocaleCredentials } from 'api/localeCredentials/useLocaleCredentials'
import type { Language } from 'ecosystem'

/**
 * App Router counterpart of the `req.cookies.NEXT_LOCALE` read that every
 * pages-router handler opens with: resolves the request's locale and installs
 * that market's api credentials into the AsyncLocalStorage the storefront api
 * client reads, so concurrent requests can't cross-contaminate each other.
 *
 * Must be awaited-on/called before the first `storefrontApi.*` call in a route.
 */
export function setRequestLocale(request: NextRequest): Language {
  const locale = (request.cookies.get('NEXT_LOCALE')?.value as Language) || 'sv'

  setLocaleCredentials(locale)

  return locale
}
